import React, { useEffect } from 'react';
import { Text } from '@moda/om';
import { loadAffirm } from '../../../vendor/affirm';
import { tc } from '../../lib/trackingContext';
import { MIN_AFFIRM_PRICE, MAX_AFFIRM_PRICE } from '../../constants';
import { useCountry } from '../CountrySelector';
import './AffirmPromoMessage.scss';

type Props = {
  price: number | string | null | undefined;
  pageType: 'product' | 'cart';
};

const DOLLARS_TO_CENTS = 100;

export const AffirmPromoMessage: React.FC<Props> = ({ pageType, price }) => {
  const { country } = useCountry();

  useEffect(() => {
    loadAffirm();
  }, []);

  useEffect(() => {
    window.affirm?.ui.ready(() => {
      window.affirm.ui.refresh();

      Object.defineProperties(window.affirm.ui.modal, {
        _hidden: {
          value: 'boolean',
          writable: true
        },
        hidden: {
          get: function () {
            return this?._hidden;
          },
          set: function (val) {
            this._hidden = val;
            if (val === false) {
              tc.track('Affirm Prequalification Selected', {
                addToScopeOnce: { price }
              });
            }
          }
        }
      });
    });
  }, [price]);

  if (country.alpha2Code !== 'US') return null;
  if (!price) return null;
  if (Number(price) < MIN_AFFIRM_PRICE || Number(price) > MAX_AFFIRM_PRICE) return null;

  return (
    <Text
      treatment="body1"
      className="AffirmPromoMessage affirm-as-low-as"
      data-page-type={pageType}
      data-amount={Math.ceil(Number(price) * DOLLARS_TO_CENTS)}
    />
  );
};
